import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { HelperService } from 'src/app/core/services/helper.service';

@Component({
  selector: 'cv-confirmation',
  templateUrl: './cv-confirmation.component.html',
  styleUrls: ['./cv-confirmation.component.scss']
})
export class CvConfirmationComponent  {

  
  @Input() title = '';
  @Input() msg = '';
  @Input() okLabel = 'Yes';
  @Input() cancelLabel = 'No';
  @Output() confirmed = new EventEmitter<boolean>();

  isVisible = false;
 close() {
    this.isVisible = false;
    this.confirmed.emit(false);
  }
  open() {
    this.isVisible = true;
  }

  confirm() {
    this.confirmed.emit(true);
    this.isVisible = false;
  }

  cancel() {
    this.confirmed.emit(false);
    this.isVisible = false;
  }
}